import styles from './styles.module.scss'
import LazyImage from '../../../../../elements/LazyImage'
import { getS3Url } from '../../../../../helpers/getS3Url'

const Item = ({ item }) => (
  <div className={styles.card}>
    <div className={styles.card__image}>
      <LazyImage
        alt={`Image Feature ${item.title}`}
        layout="fill"
        objectFit="cover"
        objectPosition="50% 68%"
        key={item.title}
        sizes="(min-width: 1250px) 300px, (max-width: 1250px) 100vw, 70vw"
        src={
          item.cloudflare_picture
            ? getS3Url(item.cloudflare_picture, '640')
            : getS3Url(item.picture)
        }
      />
    </div>

    <h3 className={styles.card__title}>{item.title}</h3>

    <div dangerouslySetInnerHTML={{ __html: item.short_description }}></div>
  </div>
)

export default Item
